module.exports = __webpack_public_path__ + "img/update.b6618946.jpeg";